import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import RouterConfig from "./navigation/RouterConfig";
import { updateIsLoggedIn } from "./redux/slices/user";
import { getUserDetails, refreshAcessToken, refreshGoogleToken } from "./services/auth";

const App = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const refresh = localStorage.getItem("refresh") || localStorage.getItem("refresh");
    if (refresh) {
      const withGoogle = localStorage.getItem("withGoogle")
      if (withGoogle === 'true') {
        let body = {
          client_id: process.env.REACT_APP_CLIENT_ID,
          client_secret: process.env.REACT_APP_CLIENT_SECRET,
          grant_type: "refresh_token",
          // backend: "google-oauth2",
          refresh_token: refresh,
        };

        refreshGoogleToken(body)
          .then(res => {
            console.log('google resp', res);
              localStorage.setItem("refresh", res.data.refresh_token);
              localStorage.setItem("access", res.data.access_token);
          })
          .catch(err => {
            console.log('google err', err.response);
            dispatch(updateIsLoggedIn(false));
            setIsLoading(false);
            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
            localStorage.removeItem("userName");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("userId");

            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
            return;
          })
        // refreshGoogleToken(body, (err, res) => {
        //   if (err) {
        //     console.log('google err', err.response);
        //     dispatch(updateIsLoggedIn(false));
        //     setIsLoading(false);
        //     localStorage.removeItem("access");
        //     localStorage.removeItem("refresh");
        //     localStorage.removeItem("userName");
        //     localStorage.removeItem("userEmail");
        //     localStorage.removeItem("userId");

        //     localStorage.removeItem("access");
        //     localStorage.removeItem("refresh");
        //     return;
        //   }
        //   console.log('google resp', res);
        //   if (localStorage.getItem("refresh")) {
        //     localStorage.setItem("access", res.data.access_token);
        //   } else {
        //     localStorage.setItem("access", res.data.access_token);
        //   }
        // });
      } else {
        refreshAcessToken(refresh, (err, res) => {
          if (err || !res.data) {
            dispatch(updateIsLoggedIn(false));
            setIsLoading(false);
            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
            localStorage.removeItem("userName");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("userId");

            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
            return;
          }
          if (localStorage.getItem("refresh")) {
            localStorage.setItem("access", res.data.access);
          } else {
            localStorage.setItem("access", res.data.access);
          }
        });
      }

    }

    if (localStorage.getItem("access") || localStorage.getItem("access")) {
      dispatch(updateIsLoggedIn(true));
      setIsLoading(false);
      getUserDetails((err, userDetails) => {
        if (err) return;
        localStorage.setItem("userName", userDetails.data.name);
        localStorage.setItem("userEmail", userDetails.data.email);
        localStorage.setItem("userId", userDetails.data.id);
      });
    } else {
      dispatch(updateIsLoggedIn(false));
      setIsLoading(false);
    }
  }, []);

  if (isLoading) return <div></div>;
  return (
    <>
      <RouterConfig />
    </>
  );
};

export default App;
